module.exports = __webpack_public_path__ + "static/media/icon6.3d77848d.svg";